module.exports = __webpack_public_path__ + "img/Duplicate.4a249410.svg";